module.exports = __webpack_public_path__ + "img/down.f3bee7cb.png";